import run from "../../animate/run";

/**
 * Immediate init element checkboxes
 * @param {GlobalSingleTriggerProps} changes
 */
const initImmediateChecks = (changes) => {
  for (const [main, names] of changes) {
    for (const name of names) {
      const trigger = /** @type {TriggerProps} */ main.store.get(name);

      /** Check if the trigger has a "target" parameter */
      const targetParameter = /** @type {Map<String, any>} */ (
        /** @type {unknown} */ (trigger?.get("p_target"))
      );

      const targetValue = targetParameter.get("value");

      /** Get the target elements */
      const targets = targetValue ? targetValue : [main.element];

      for (const target of targets) {
        if (target.checked) {
          main.isImmediate = true;
          run(main.events.get(`change:${name}`), "enter");
        }
      }
    }
  }
};

export default initImmediateChecks;
